import { Mail, Printer } from "lucide-react";
import { FilterLoadLists } from "./filter-load-lists";
import { ListVessels } from "./list-vessels";

export const LoadLists = () => {
  

  return (
    <div className="bg-gray-50">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-semibold">Load Lists</h1>
          <p className="text-gray-600 mt-1">Track inventory loading from warehouse to vessels for delivery</p>
        </div>
        <div className="flex space-x-4">
          <button className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50 bg-white shadow-sm">
            <Printer size={16} />
            <span>Print All</span>
          </button>
          <button className="flex items-center space-x-2 px-4 py-2 border rounded-lg hover:bg-gray-50 bg-white shadow-sm">
            <Mail size={16} />
            <span>Email All</span>
          </button>
        </div>
      </div>

      {/* Filters */}
      <FilterLoadLists />

      {/* Load List */}
      <ListVessels />
    </div>
  );
};
